import { Affiliate } from '../../../global';
import utilSvc from '../../core/utilSvc';

// STORAGE KEYS
export const CP_ORDER_INVOICES_LIST_STORAGE_KEY = 'order-cp-order-invoices-list';
export const CP_ORDER_INVOICES_LIST_VIEW_KEY = 'tv-order-cp-order-invoices-list';
export const CP_ORDER_INVOICES_LIST_FORM_KEY = 'order-cp-order-invoices-form';

// EXCEL FILE NAME
export const CP_ORDER_INVOICES_LIST_EXCEL_FILE_NAME = 'Verity-CPOrderInvoicesList';

// ROUTE
export const CP_ORDER_INVOICES_ROUTE_LIST = 'invoice2.cp.list';
export const CP_ORDER_INVOICES_ROUTE_DETAILS = 'invoice2.cpdetail';

export const getAffs = (affList: Affiliate[] | undefined, featureName: string): Affiliate[] => {
    if (affList) {
        let affs = utilSvc.aff.findStatus(affList);
        affs = utilSvc.aff.findRxType(affs, ['DISPENSING', 'CENTRALFILL']);
        affs = utilSvc.aff.findRxModel(affs, utilSvc.aff.rxModelsByFeature(featureName));
        return affs;
    }
    return [];
};

export const FEATURE_NAME = 'invoice.cp';
